import React, { useContext, useEffect, useState } from "react";
import { Card, Form, Modal, Skeleton, Space, Spin, Table, Tooltip, Upload } from "antd";
import { userprofile } from "hooks/api/myplanapi";
import useGetData from "components/common/useGetData";
import { ImagePaths } from "utils/ImagePath";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { imgUploadSize } from 'components/common/enum';
import ToastMsg from "components/common/ToastMsg";
import MyButton from "components/ui/Button/MyButton";
import { USER_PROFILE, PROFILE_CHANGE_PASSWORD } from "constants";
import { AuthContext } from "context/auth/authentication";
import { Navigate } from "react-router-dom";
import IconButton from "components/ui/Button/IconButton";
import moment from "moment";
import { CopyOutlined } from "@ant-design/icons";

import { Tabs } from 'antd';

const { TabPane } = Tabs;

const EmployeeProfile = () => {
    const authtoken = sessionStorage.getItem("token");
    const [imageUrl, setImageUrl] = useState("");
    const [form] = Form.useForm();
    const [uploadLoading, setUploadLoading] = useState(false);
    const [profileList, setProfileList] = useState([]);
    const [imageProfile, setimageProfile] = useState([]);
    const is_password_updated = JSON.parse(sessionStorage.getItem("is_password_updated"));
    const [isNotifyPopup, setIsNotifyPop] = useState(false);
    const { logoutauth } = useContext(AuthContext);
    const [activeTab, setActiveTab] = useState("Personal Information");
    const [personalInfo, setPersonalInfo] = useState(null);
    const [assetInfo, setAssetInfo] = useState(null);
    const [salaryInfo, setSalaryInfo] = useState(null);
    const [documentInfo, setdocumentInfo] = useState(null);

    const tabs = [
        "Personal Information",
        "Asset Info",
        "Documentation",
        "Salary Info",
    ];

    useEffect(() => {
        if (!authtoken) {
            window.location.href = "/";
        }
    }, [authtoken]);
    const [formData, setFormData] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",
        profile: []
    });
    const [data, message, refetch, loading] = useGetData(userprofile);
    console.log(loading);

    useEffect(() => {
        setImageUrl(data?.image_url)
        setPersonalInfo(data?.Personal_Information || {});
        setAssetInfo(data?.Asset_Information || {});
        const salaryInfo = data?.Salary_Info?.[0] ?? {};
        setSalaryInfo(salaryInfo);
        setdocumentInfo(data?.Documentation || {});
    }, [data])

    const handleImgChange = (fileList) => {
        if (fileList?.length > 0 && fileList[0]?.originFileObj) {
            const uploadedFile = fileList[0].originFileObj;
            const imgUrl = URL.createObjectURL(uploadedFile);
            setFormData({
                ...formData,
                profile: fileList,
            });
            form.setFields([
                {
                    name: "profile",
                    value: uploadedFile ? [uploadedFile] : [],
                }
            ]);
            setProfileList(uploadedFile ? [uploadedFile] : []);
            setImageUrl(imgUrl);
            setimageProfile("profile_document", fileList);
            try {
                setUploadLoading(true)
                const dataForm = new FormData();
                dataForm.append("profile", fileList[0]?.originFileObj)
                fetch(USER_PROFILE, {
                    method: "POST",
                    headers: {
                        'Authorization': `token ${authtoken}`
                    },
                    body: dataForm
                })
                    .then((response) => response.json())
                    .then(async data => {
                        if (data.status === "success") {
                            sessionStorage.setItem("profile", imgUrl)

                            ToastMsg("success", data.message);
                            setUploadLoading(false);
                            setFormData({
                                profile: [],
                            })
                        }
                        else if (data.status === "fail") {
                            setUploadLoading(false);
                            ToastMsg("error", data.message);
                        }
                    })
                    .catch(error => {
                        setUploadLoading(false);
                        ToastMsg("error", error.message);
                    });
            } catch (error) {
                ToastMsg("error", error.message);
            }
        }
    };

    const handleDownloadDocs = (fileUrl) => {
        if (fileUrl) {
            downloadPDF(fileUrl);
        }
    };

    const downloadPDF = (url) => {
        const link = document.createElement('a');
        link.href = url;
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().slice(0, 19).replace(/[-T]/g, '').replace(/:/g, '');
        link.setAttribute('download', `${formattedDate}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const profileProps = {
        onRemove: (file) => {
            const index = profileList.indexOf(file);
            const newFileList = profileList.slice();
            newFileList.splice(index, 1);
            setProfileList(newFileList);
        },
        beforeUpload: (file) => {
            const isLt2M = file.size / 1024 / 1024 < imgUploadSize;
            if (!isLt2M) {
                ToastMsg("error", `Image must smaller than ${imgUploadSize}MB!`);
                return false;
            }
            setProfileList([...profileList, file]);
            return false;
        },
        profileList,
    };
    const uploadButton = (
        <div>
            {uploadLoading ? <LoadingOutlined style={{ fontSize: "1vw" }} /> : <PlusOutlined style={{ fontSize: "1vw" }} />}
            <div style={{ fontSize: "1vw", marginTop: 8 }}>Upload</div>
        </div>
    );

    const columns = [
        { title: 'Asset ID', dataIndex: 'asset_id', key: 'asset_id' },
        { title: 'Asset Name', dataIndex: 'asset_name', key: 'asset_name' },
        {
            title: 'Asset Issued Date', dataIndex: 'issued_date', key: 'issued_date',
            render: (_, record) =>
                <p style={{ color: "black" }} className="capitalize">{record?.issued_date ? moment(record.issued_date).format("DD-MM-YYYY") : "-"}</p>
        },
        { title: 'Asset Issued By', dataIndex: 'issued_by', key: 'issued_by' },
    ];

    const columns_Earning = [
        { title: 'Salary Component', dataIndex: 'name', key: 'name' },
        { title: 'Calculation (%)', dataIndex: 'percentage', key: 'percentage' },
        { title: 'Monthly Amount(₹)', dataIndex: 'monthly_amount', key: 'monthly_amount' },
        { title: 'Annual Amount(₹)', dataIndex: 'annual_amount', key: 'annual_amount' },
    ];
    const columns_Deductions = [
        { title: 'Salary Component', dataIndex: 'name', key: 'name' },
        { title: 'Calculation (%)', dataIndex: 'employee_share_percentage', key: 'employee_share_percentage' },
        { title: 'Monthly Amount(₹)', dataIndex: 'employee_share_monthly_amount', key: 'employee_share_monthly_amount' },
        { title: 'Annual Amount(₹)', dataIndex: 'annual_amount', key: 'annual_amount' },
    ];

    const columns_Doc = [
        {
            title: 'Documents',
            dataIndex: 'document',
            key: 'document',
            width: "30%",
            fixed: "left",
        },
        {
            title: 'Document Upload On',
            dataIndex: 'uploaded_on',
            key: 'uploaded_on',
            width: "30%",
            fixed: "left",
            render: (_, record) =>
                <p style={{ color: "black" }} className="capitalize">{record?.uploaded_on ? moment(record.uploaded_on).format("DD-MM-YYYY") : "-"}</p>
        },
        {
            title: 'Action',
            key: 'operation',
            width: "40%",
            fixed: "left",
            align: 'center',
            render: (_, record) => (
                <div className="flex justify-center items-center">
                    <Space size={"middle"}>
                        <IconButton
                            title="Download"
                            icon={<img
                                src={record.document ? ImagePaths.documentPdfOn.default
                                    : ImagePaths.documentPdfOff.default}
                                alt="Download"
                            />}
                            onClick={() => handleDownloadDocs(record?.document_url)}
                            disabled={!record.document_url}
                        />
                    </Space>
                </div>
            ),
        }
    ];

    const copyToClipboard = (text) => {
        if (text) {
            navigator.clipboard.writeText(text);
            ToastMsg('success', 'Text copied')
        }
    };

    return (
        <>
            {loading ? (
                <div className="flex gap-3 h-full">
                    {/* Skeleton for Left Card */}
                    <Card className="shadow-md rounded-md p-2 w-[38%]">
                        <Skeleton.Avatar active size={96} shape="circle" className="mx-auto mb-4" />
                        <Skeleton active paragraph={{ rows: 3 }} title={{ width: '60%' }} className=" mb-2" />
                        <Skeleton active paragraph={{ rows: 8 }} title={false} />
                    </Card>

                    {/* Skeleton for Right Card (Tabs Content) */}
                    <Card className="shadow-md rounded-md p-2 w-[62%]">
                        <Skeleton.Button active size="small" style={{ width: 120, marginBottom: 16 }} />
                        <Skeleton active paragraph={{ rows: 8 }} />
                    </Card>
                </div>
            ) : (
                <span className=" flex gap-3 h-full">
                    <Card className=" shadow-md rounded-md p-2 w-[38%]">
                        {/* Title */}
                        {/* <h2 className="text-xl font-semibold text-gray-800 mb-2">Employee Profile</h2> */}

                        <div className=" flex justify-between border-b">
                            <div>
                                {/* Profile Image Upload */}
                                <Form.Item
                                    name="profile"
                                    fileList={profileList}
                                    style={{ textAlign: "center" }}
                                >
                                    <div className="flex justify-center items-center h-[20vh]">
                                        <Upload
                                            {...profileProps}
                                            listType="picture-circle"
                                            showUploadList={false}
                                            onChange={({ fileList }) => handleImgChange(fileList)}
                                            fileList={profileList}
                                            accept=".jpg,.jpeg,.png"
                                            maxCount={1}
                                        >
                                            {imageUrl ? (
                                                <img
                                                    src={imageUrl}
                                                    alt="avatar"
                                                    className="w-24 h-24 object-cover rounded-full border shadow"
                                                />
                                            ) : (
                                                uploadButton
                                            )}
                                        </Upload>
                                    </div>
                                </Form.Item>
                            </div>
                            <div>
                                {/* Name and Designation */}
                                <div className="text-left">
                                    <p className="text-sm font-semibold text-gray-700">{data?.name || "-"}</p>
                                    <p className="text-xs text-gray-500">{data?.designation || "-"}</p>
                                </div>
                                {/* Basic Info */}
                                <div className="py-4">
                                    {/* <h3 className="text-[13px] font-medium text-gray-700 mb-2">Basic Information</h3> */}
                                    <div className="space-y-2 text-sm text-gray-600">
                                        <div className="flex items-center text-xs">
                                            <img className="w-4 h-4 mr-2" src={ImagePaths.contact.default} alt="email" />
                                            {data?.email || "-"}
                                        </div>
                                        <div className="flex items-center text-xs">
                                            <img className="w-4 h-4 mr-2" src={ImagePaths.call.default} alt="phone" />
                                            {data?.phone || "-"}
                                        </div>
                                        <div className="flex items-center text-xs">
                                            <img className="w-4 h-4 mr-2" src={ImagePaths.location.default} alt="location" />
                                            {data?.location || "-"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Professional Info */}
                        <div className="py-4 border-b border-gray-300">
                            <h3 className="text-[13px] font-medium text-gray-700 mb-4">Professional Information</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 text-xs text-gray-600">
                                <div>
                                    <p className="font-semibold">Employee ID</p>
                                    <p>{data?.employee_id || "-"}</p>
                                </div>
                                <div>
                                    <p className="font-semibold">Employee Type</p>
                                    <p>{data?.employee_type || "-"}</p>
                                </div>
                                <div>
                                    <p className="font-semibold">Department</p>
                                    <p>{data?.department || "-"}</p>
                                </div>
                                <div>
                                    <p className="font-semibold">Designation</p>
                                    <p>{data?.designation || "-"}</p>
                                </div>
                                <div>
                                    <p className="font-semibold">Reporting Manager</p>
                                    <p>{data?.reporting_manager || "-"}</p>
                                </div>
                                <div>
                                    <p className="font-semibold">Shift</p>
                                    <p>{data?.shift || "-"}</p>
                                </div>
                            </div>
                        </div>

                        {/* Bank Info */}
                        <div className="py-4">
                            <h3 className="text-[13px] font-medium text-gray-700 mb-4">Bank Information</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 text-xs text-gray-600">
                                <div>
                                    <p className="font-semibold">Bank Name</p>
                                    <p>{data?.bank_details?.bank_name || "-"}</p>
                                </div>
                                <div>
                                    <p className="font-semibold">Account Number</p>
                                    <div className=" flex gap-2">
                                        <p>{data?.bank_details?.account_number || "-"}</p>
                                        {data?.bank_details?.account_number && (
                                            <CopyOutlined
                                                className="text-gray-500 hover:text-blue-500 cursor-pointer"
                                                onClick={() => copyToClipboard(data.bank_details.account_number)}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <p className="font-semibold">IFSC Code</p>
                                    <div className=" flex gap-2">
                                        <p>{data?.bank_details?.ifsc || "-"}</p>
                                        {data?.bank_details?.ifsc && (
                                            <CopyOutlined
                                                className="text-gray-500 hover:text-blue-500 cursor-pointer"
                                                onClick={() => copyToClipboard(data.bank_details.ifsc)}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Card>

                    <Card className=" shadow-md rounded-md p-2 w-[62%]">
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Personal Information" key="1">
                                <div className=" h-96 overflow-y-scroll">
                                    {/* Section: Personal Information */}
                                    <div className="mb-6 border-b pb-4">
                                        <h3 className="text-[13px] font-medium text-gray-700 mb-4">Personal Information</h3>
                                        <div className="grid grid-cols-3 gap-4 text-xs text-gray-600">
                                            <div>
                                                <p className="font-semibold">Gender</p>
                                                <p className="capitalize">{personalInfo?.gender || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Blood Group</p>
                                                <p>{personalInfo?.blood_group || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Date of Birth</p>
                                                <p>{personalInfo?.date_of_birth || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Mobile No</p>
                                                <p>{personalInfo?.personal_mobile_no || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Email ID</p>
                                                <p>{personalInfo?.personal_email_id || "-"}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Section: Permanent Address */}
                                    <div className="mb-6 border-b pb-4">
                                        <h3 className="text-[13px] font-medium text-gray-700 mb-4">Permanent Address</h3>
                                        <div className="text-xs text-gray-600 space-y-2 mb-4">
                                            <p className="font-semibold">Address</p>
                                            <p>{personalInfo?.permanant_address || "-"}</p>
                                        </div>
                                        <div className="grid grid-cols-3 gap-4 text-xs text-gray-600">
                                            <div>
                                                <p className="font-semibold">Pincode</p>
                                                <p>{personalInfo?.pincode || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">City</p>
                                                <p>{personalInfo?.city || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">State</p>
                                                <p>{personalInfo?.state || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Country</p>
                                                <p>{personalInfo?.country || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Contact Person</p>
                                                <p>{personalInfo?.contact_person_name || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Relationship</p>
                                                <p>{personalInfo?.relationship_type || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Contact Number</p>
                                                <p>{personalInfo?.contact_person_number || "-"}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Section: Present Address */}
                                    <div className="mb-6 border-b pb-4">
                                        <h3 className="text-[13px] font-medium text-gray-700 mb-4">Present Address</h3>
                                        <div className="text-xs text-gray-600 space-y-2 mb-4">
                                            <p className="font-semibold">Address</p>
                                            <p>{personalInfo?.present_address || "-"}</p>
                                        </div>
                                        <div className="grid grid-cols-3 gap-4 text-xs text-gray-600">
                                            <div>
                                                <p className="font-semibold">Pincode</p>
                                                <p>{personalInfo?.present_pincode || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">City</p>
                                                <p>{personalInfo?.persent_city || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">State</p>
                                                <p>{personalInfo?.present_state || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Country</p>
                                                <p>{personalInfo?.present_country || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Emergency Contact</p>
                                                <p>{personalInfo?.emergency_contact_person || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Relationship</p>
                                                <p>{personalInfo?.emergency_contact_relationship || "-"}</p>
                                            </div>
                                            <div>
                                                <p className="font-semibold">Contact Number</p>
                                                <p>{personalInfo?.emergency_contact_number || "-"}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </TabPane>
                            <TabPane tab="Asset Info" key="2">
                                <div className=" h-96 overflow-y-scroll">
                                    <div style={{ border: "1px solid #cac9c9" }} className=" rounded-lg p-2">
                                        <Table
                                            rowKey={(record) => record?.id}
                                            dataSource={assetInfo}
                                            columns={columns}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tab="Documentation" key="3">
                                <div className=" h-96 overflow-y-scroll">
                                    <div style={{ border: "1px solid #cac9c9" }} className=" rounded-lg p-2">
                                        <Table
                                            rowKey={(record) => record?.id}
                                            columns={columns_Doc}
                                            dataSource={documentInfo}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tab="Salary Info" key="4">
                                <div className=" h-96 overflow-y-auto bg-white rounded-md shadow-sm p-4">
                                    {/* CTC Information */}
                                    <div className="grid grid-cols-2 gap-4 border-b pb-4 mb-4">
                                        <div className=" flex gap-2">
                                            <p className="text-xs text-gray-500 font-medium">Monthly CTC</p>
                                            <p className="text-xs font-semibold text-gray-800">
                                                {salaryInfo?.monthly_ctc ?? '-'}
                                            </p>
                                        </div>
                                        <div className=" flex gap-2">
                                            <p className="text-xs text-gray-500 font-medium">Annual CTC</p>
                                            <p className="text-xs font-semibold text-gray-800">
                                                {salaryInfo?.annual_ctc ?? '-'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Earnings Section */}
                                    <div className="mb-6">
                                        <p className="text-xs font-semibold text-gray-700 mb-2">Earnings</p>
                                        <div className="border border-gray-300 rounded-md overflow-hidden">
                                            <Table
                                                rowKey={(record) => record?.id}
                                                dataSource={salaryInfo?.earnings}
                                                columns={columns_Earning}
                                                pagination={false}
                                            />
                                        </div>
                                    </div>

                                    {/* Deductions Section */}
                                    <div>
                                        <p className="text-xs font-semibold text-gray-700 mb-2">Deductions</p>
                                        <div className="border border-gray-300 rounded-md overflow-hidden">
                                            <Table
                                                rowKey={(record) => record?.id}
                                                dataSource={salaryInfo?.deductions}
                                                columns={columns_Deductions}
                                                pagination={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                    </Card>
                </span>
            )
            }
        </>
    );
}

const styles = {
    textField: {
        width: "23vw"
    },
    formItem: {
        margin: "1vw"
    },
    emptyFormItem: {
        width: "23vw",
        margin: "1vw"
    }
}

export default EmployeeProfile